// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"si-z","centerLink":"ti-z","productSection":"ui-z","item":"vi-z","ctaButton":"wi-z"};